<template>
    <el-footer class="my-area">
        <div class="my-footer">
            <p>
                <strong>
                    <div class="footer-item">
                        <router-link to="/" class="my-login-design-color">Copyright © 2022 苏七的个人博客</router-link>
                        <a href="https://beian.miit.gov.cn/" target="_blank">备案号：{{recordNumber}}</a>
                    </div>
                </strong>
            </p>
        </div>
    </el-footer>

</template>

<script>

    export default {
        name: 'BaseFooter',
        data() {
            return {
                recordNumber: "蜀ICP备2022002934"
            }
        },
        methods: {},
        mounted() {
        }
    }
</script>

<style>
    .el-footer {
        min-width: 100%;
        box-shadow: 0 -3px 3px hsla(0, 0%, 7%, .1), 0 0 0 0px hsla(0, 0%, 7%, .1);
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1024;
    }

    .my-footer {
        text-align: center;
        line-height: 40px;
        font-family: FZShuTi, serif;
        font-size: 24px;
    }

    .footer-item {
        display: flex;
        flex-direction: column;
    }

    .footer-item a:not(:first-child) {
        color: black;
    }

    .my-login-design-color {
        color: #00aaff !important;
    }
</style>
